import { ref, onMounted } from 'vue'
import request from '@/api/request'

/**
 * 客服管理 Composable
 * 用于获取和管理24小时在线客服信息
 */
export function useCustomerService() {
  const services = ref([])
  const loading = ref(false)

  // 加载所有启用的客服
  const loadServices = async () => {
    loading.value = true
    try {
      const response = await request.get('/customer-services/all')
      if (response.code === 200) {
        services.value = response.data || []
      }
    } catch (error) {
      console.error('加载客服列表失败:', error)
    } finally {
      loading.value = false
    }
  }

  // 获取微信联系方式（第一个有微信的客服）
  const getWechatContact = () => {
    return services.value.find(s => s.wechat)?.wechat || ''
  }

  // 获取WhatsApp联系方式（第一个有WhatsApp的客服）
  const getWhatsappContact = () => {
    return services.value.find(s => s.whatsapp)?.whatsapp || ''
  }

  // 在组件挂载时自动加载
  onMounted(() => {
    loadServices()
  })

  return {
    services,
    loading,
    loadServices,
    getWechatContact,
    getWhatsappContact
  }
}
